import { Component, OnInit, ViewChild, ChangeDetectorRef } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { MatDialog } from "@angular/material/dialog";
import { BackendApiService } from "../../../app/services/backend-api.service";
import { BaseUrlConstantsService } from "../../../app/services/base-url-constants.service";
import { DatePipe } from "@angular/common";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import moment from "moment-timezone";
import { DialogOverviewExampleDialogComponent } from "../../dialog-overview-example-dialog/dialog-overview-example-dialog.component";
// import { ConvertDatetimePipe } from "../../../app/convert-datetime.pipe";
import { FormControl, FormGroup } from "@angular/forms";
import { validateHorizontalPosition } from "@angular/cdk/overlay";
import { MatToolbarModule } from '@angular/material/toolbar';
import { CommonModule } from "@angular/common";
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { MatNativeDateModule } from '@angular/material/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from "@angular/material/button";
@Component({
  selector: "app-error-log",
  templateUrl: "./error-log.component.html",
  styleUrls: ["./error-log.component.scss"],
  standalone:true,
  imports: [MatToolbarModule,CommonModule,FormsModule,MatFormFieldModule,MatDatepickerModule,MatInputModule,MatNativeDateModule,ReactiveFormsModule,MatButtonModule],
  providers:[DatePipe]
})
export class ErrorLogComponent implements OnInit {
  public ErrorPannelService: string = BaseUrlConstantsService.BASE_PANNEL_Log;
  public reportServiceUrl = BaseUrlConstantsService.BASE_ASSET_REPORT_URL;
  public report_generate = BaseUrlConstantsService.Generate_new_url;
  public errordata: any[];
  public clientid: any;
  public role: string;
  public clientname: string;
  public CompanyName: string;
  public showEmptyError: string = "Fetching reports, please wait..";
  public selectedErrorLog: any = null;

  // Search and date range criteria properties
  searchUserName: string = "";
  searchSiteName: string = "";
  searchAppName: string = "";
  searchSerialNumber: string = "";
  startDate: Date | null = null;
  endDate: Date | null = null;
  filteredData: any[] = [];
  currentVisibleData: any[] = [];
  macAdd: string = "";
  clientName: string = "";
  sNumber: string = "";
  site: string = "";
  application: string = "";
  filtersApplied: boolean = false;
  userID: any;
  allDeviceSecondArray = [];
  reportDataArr = [];
  public paginatedReportDataArr: any = [];
  range = new FormGroup({
    start: new FormControl(),
    end: new FormControl(),
  });

  // Pagination-related properties
  currentPage: number = 1;
  itemsPerPage: number = 10;

  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(
    public router: Router,
    public dialog: MatDialog,
    private service: BackendApiService,
    public datepipe: DatePipe,
    private cdr: ChangeDetectorRef
  ) {
    this.userID = localStorage.getItem("user_id");
  }

  ngOnInit() {
    this.clientname = localStorage.getItem("user_name");
    this.CompanyName = localStorage.getItem("company_name");
    this.clientid = localStorage.getItem("user_id");
    this.role = localStorage.getItem("role");
    this.fetchErrorData();
    // this.getallDevices("","","","")
  }

  private async fetchErrorData() {
    const belongToParam =
      Math.floor(Math.random() * 90 + 10) +
      this.clientid +
      Math.floor(Math.random() * 9000 + 1000);

    /*
    https://devapi.enertics.ca/alertreport/alert/error/?role=CLIENT&full_name=&asset_serial_no=&site_name=&app_name=&startDate=&endDate=
&client_id=
    */
    let url = `${this.ErrorPannelService}?role=${this.role}`;
    if (this.role === "CLIENT") {
      url = `${url}&client_id=${belongToParam}&role=${this.role}`;
    }
    try {
      const response: any = await this.service.loadPannelData(url);
      this.errordata = response.data?.body || [];
      this.filteredData = [...this.errordata]; // Initialize filtered data
      this.updateVisibleData(); // Initialize the visible data
      this.showEmptyError = "";
    } catch (error) {
      console.error("Error fetching data:", error);
      this.showEmptyError = "Error in fetching data";
    }
  }

  filterData() {
    this.applyFilters();
    this.resetPagination();
    this.updateVisibleData();
  }

  applyDateRangeFilter() {
    this.applyFilters();
    this.resetPagination();
    this.updateVisibleData();
  }

  clearFilters() {
    this.fetchErrorData();
    this.range.controls["start"].setValue(null);
    this.range.controls["end"].setValue(null);
    this.clientname = "";
    this.site = "";
    this.application = "";
    this.sNumber = "";
    this.searchUserName = "";
    this.searchSiteName = "";
    this.searchAppName = "";
    this.searchSerialNumber = "";
    this.startDate = null;
    this.endDate = null;
    this.clientName = "";
    this.filteredData = [...this.errordata];
    this.resetPagination();
    this.updateVisibleData();
  }

  private applyFilters() {
    this.filteredData = this.errordata.filter((item) => {
      return (
        this.matchesFilters(item) && this.matchesDateRange(item.error_locktime)
      );
    });
  }

  private matchesFilters(item: any): boolean {
    return (
      item.full_name
        .toLowerCase()
        .includes(this.searchUserName.toLowerCase()) &&
      item.site_name
        .toLowerCase()
        .includes(this.searchSiteName.toLowerCase()) &&
      item.app_name.toLowerCase().includes(this.searchAppName.toLowerCase()) &&
      item.asset_serial_no
        .toLowerCase()
        .includes(this.searchSerialNumber.toLowerCase())
    );
  }

  private matchesDateRange(errorLockTime: string): boolean {
    const errorDate = moment(errorLockTime);
    const startDate = this.startDate
      ? moment(this.startDate).startOf("day")
      : null;

    const endDate = this.endDate
      ? moment(this.endDate).add(1, "days").startOf("day")
      : null;
    return (
      (!startDate || errorDate.isSameOrAfter(startDate)) &&
      (!endDate || errorDate.isBefore(endDate))
    );
  }

  private resetPagination() {
    this.currentPage = 1;
    if (this.paginator) {
      this.paginator.firstPage();
    }
  }

  onPageChange(event: PageEvent) {
    this.currentPage = event.pageIndex + 1;
    this.itemsPerPage = event.pageSize;
    this.updateVisibleData();
  }

  private updateVisibleData() {
    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    const endIndex = startIndex + this.itemsPerPage;
    const visibleDataSlice = this.filteredData.slice(startIndex, endIndex);
    this.paginatedReportDataArr = this.processErrorData(visibleDataSlice);
  }

  async downloadErrorLogs() {
    const belongToParam =
      Math.floor(Math.random() * 90 + 10) +
      this.clientid +
      Math.floor(Math.random() * 9000 + 1000);

    // Define the URL for downloading the error logs report
    const downloadReportEndpoint = `${this.reportServiceUrl}error-reports-download`;

    let queryParams = `?role=${encodeURIComponent(this.role)}`;

    if (this.role !== "ADMIN") {
      queryParams += `&client_id=${encodeURIComponent(belongToParam)}`;
    }

    queryParams +=
      `&asset_serial_no=${encodeURIComponent(this.searchSerialNumber)}` +
      `&app_name=${encodeURIComponent(this.searchAppName)}` +
      `&site_name=${encodeURIComponent(this.searchSiteName)}` +
      `&full_name=${encodeURIComponent(this.searchUserName)}` +
      `&startDate=${encodeURIComponent(
        this.startDate ? moment(this.startDate).format("YYYY-MM-DD") : ""
      )}` +
      `&endDate=${encodeURIComponent(
        this.endDate ? moment(this.endDate).format("YYYY-MM-DD") : ""
      )}`;
    try {
      const response = await fetch(`${downloadReportEndpoint}?${queryParams}`);
      const data = await response.json();

      if (data.status === 200 && data.key) {
        this.viewAReport(data.key);
        console.log(data.key, "keyPresigned");
      } else {
        console.error("Error downloading audit report:", data.message);
      }
    } catch (error) {
      console.error("Error downloading audit report:", error);
    }
    // Navigate to the URL
    // window.open(`${downloadReportEndpoint}${queryParams}`, "_blank");
  }
  viewAReport(url) {
    let body: any = {
      key: url,
    };
    this.service
      .postAssetReport(this.report_generate + "/" + "pre-signed-url", body)
      .then((res) => {
        if (JSON.parse(JSON.stringify(res)).status == "success") {
          if (JSON.parse(JSON.stringify(res)).body != "") {
            let report_url = JSON.parse(JSON.stringify(res)).body;
            window.open(report_url, "_blank");
          } else {
            this.service.showError("Something went wrong");
          }
        } else {
          this.service.showError("Something went wrong");
        }
      });
  }

  public viewErrorLogDetails(errorLog: any): void {
    this.selectedErrorLog = errorLog;

    if (errorLog !== undefined) {
      const dialogRef = this.dialog.open(DialogOverviewExampleDialogComponent, {
        width: "700px",
        maxWidth: "815vw",
        height: "500px",
        data: {
          type: "errorLogDialogBox",
          error_log: errorLog,
        },
      });
    }
  }

  private processErrorData(data: any[]): any[] {
    return data.map((item) => {
      if (
        item.alert_comments_history &&
        item.alert_comments_history.length > 0
      ) {
        const latestHistory = item.alert_comments_history[0];
        return {
          ...item,
          latestAcknowledgedTime: latestHistory.acknowledge_time,

          latestAcknowledgedBy: latestHistory.acknowledged_by,
        };
      } else {
        return {
          ...item,
          latestAcknowledgedTime: "N/A",
          latestAcknowledgedBy: "N/A",
        };
      }
    });
  }

  searchbyname(ev) {
    console.log(ev);
    const term = ev;
    //this.macAdd = "";
    this.clientName = ev;
    //this.sNumber = "";
    this.getallDevices(
      this.clientName,
      this.sNumber,
      this.site,
      this.application
    );
  }
  searchbySerialNo(ev) {
    const term = ev;
    //this.macAdd = "";
    //this.clientName = "";
    this.sNumber = ev;
    this.getallDevices(
      this.clientName,
      this.sNumber,
      this.site,
      this.application
    );
  }
  searchbySite(ev) {
    const term = ev;
    //this.macAdd = "";
    //this.clientName = "";
    //this.sNumber = "";
    this.site = ev;
    this.getallDevices(
      this.clientName,
      this.sNumber,
      this.site,
      this.application
    );
  }
  searchbyApplication(ev) {
    const term = ev;
    //this.macAdd = "";
    //this.clientName = "";
    //this.sNumber = "";
    //this.site=""
    this.application = ev;
    this.getallDevices(
      this.clientName,
      this.sNumber,
      this.site,
      this.application
    );
  }
  async getallDevices(client, serial_number, site, application) {
    console.log(client, serial_number, site, application);
    this.filtersApplied =
      client || serial_number || site || application ? true : false;
    const userRole = localStorage.getItem("role");
    const belongToParam =
      Math.floor(Math.random() * 90 + 10) +
      this.userID +
      Math.floor(Math.random() * 9000 + 1000);

    try {
      let url = `${this.ErrorPannelService}?role=${this.role}&full_name=${client}&asset_serial_no=${serial_number}&site_name=${site}&app_name=${application}`;
      const response = await this.service.getData(`${url}`);
      if (this.role === "CLIENT") {
        url = `${url}&client_id=${belongToParam}&role=${this.role}&full_name=${client}&asset_serial_no=${serial_number}&site_name=${site}&app_name=${application}`;
      }
      console.log(url);
      const responseBody = JSON.parse(JSON.stringify(response));
      console.log(responseBody);
      if (
        responseBody.data &&
        responseBody.data.body &&
        responseBody.data.body
      ) {
        this.allDeviceSecondArray = responseBody.data.body.map((val) => {
          if (
            val.alert_comments_history &&
            val.alert_comments_history.length > 0
          ) {
            const latestHistory = val.alert_comments_history[0];
            return {
              ...val,
              latestAcknowledgedTime: latestHistory.acknowledge_time,

              latestAcknowledgedBy: latestHistory.acknowledged_by,
            };
          } else {
            return {
              ...val,
              latestAcknowledgedTime: "N/A",
              latestAcknowledgedBy: "N/A",
            };
          }
        });
        this.filteredData = [...this.allDeviceSecondArray];
        this.reportDataArr = this.allDeviceSecondArray;
        console.log(this.reportDataArr);
        this.updatePaginatedData(); // Add this line
        this.showEmptyError = "";
      } else {
        this.showEmptyError = "No Reports Available!";
        this.reportDataArr = [];
      }
    } catch (error) {
      console.error("Error fetching data: ", error);
      this.showEmptyError = "Error fetching data";
    }
  }

  private updatePaginatedData() {
    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    const endIndex = startIndex + this.itemsPerPage;
    this.paginatedReportDataArr = this.reportDataArr.slice(
      startIndex,
      endIndex
    );
    console.log(this.paginatedReportDataArr);
    this.cdr.detectChanges(); // Update the view
  }

  async onDateRangeChange(start: Date, end: Date) {
    // Formatting start and end dates
    const formattedStartDate = moment(start)
      .set({ hour: 0, minute: 0, second: 0 })
      .format("YYYY-MM-DD HH:mm:ss");

    var formattedEndDate = moment(end == null ? new Date() : end)
      .set({ hour: 23, minute: 59, second: 59 })
      .format("YYYY-MM-DD HH:mm:ss");
    console.log("Date Range:", formattedStartDate, formattedEndDate);
    // formattedEndDate == "Invalid%20date" ? "" : formattedEndDate;
    if (formattedEndDate == "Invalid date") {
      formattedEndDate = "";
    }
    const userRole = localStorage.getItem("role");
    const belongToParam =
      Math.floor(Math.random() * 90 + 10) +
      this.userID +
      Math.floor(Math.random() * 9000 + 1000);

    let url = `${this.ErrorPannelService}?role=${this.role}&full_name=${this.clientName}&asset_serial_no=${this.sNumber}&site_name=${this.site}&app_name=${this.application}&startDate=${formattedStartDate}&endDate=${formattedEndDate}`;
    // Set filtersApplied to true as we are applying a date filter
    this.filtersApplied = true;

    try {
      const response = await this.service.getData(url);
      console.log("API Response:", response);

      const responseBody = JSON.parse(JSON.stringify(response));
      if (
        responseBody.data &&
        responseBody.data.body &&
        responseBody.data.body.length > 0
      ) {
        this.reportDataArr = responseBody.data.body.map((val) => {
          if (
            val.alert_comments_history &&
            val.alert_comments_history.length > 0
          ) {
            const latestHistory = val.alert_comments_history[0];
            return {
              ...val,
              latestAcknowledgedTime: latestHistory.acknowledge_time,

              latestAcknowledgedBy: latestHistory.acknowledged_by,
            };
          } else {
            return {
              ...val,
              latestAcknowledgedTime: "N/A",
              latestAcknowledgedBy: "N/A",
            };
          }
        });
        this.filteredData = [...this.reportDataArr];

        this.updatePaginatedData(); // Update the paginated data
        this.showEmptyError = "";
      } else {
        // Set an appropriate message when there are no records after filtering
        this.paginatedReportDataArr = [];
        this.showEmptyError = "No records available for this filter criteria";
      }
    } catch (error) {
      console.error("Error fetching data: ", error);
      this.showEmptyError = "Error fetching data";
    }
  }
}
